import React, { useState, useEffect } from 'react';
import { Container, InputField } from '@common';
import DataTableReact from '@common/datatable/DataTableReact.jsx';
import apiService from 'services/apiService';
import { Dots } from '../../assets/svg.js';
import { Menu, MenuItem } from '@mui/material';
import CustomModal from '@common/CustomModal/CustomModal.js';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FaPlus } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';

function Specialties() {
  const [specialties, setSpecialties] = useState([]);
  const [editableSpecialtie, setEditableSpecialtie] = useState(null);
  const [openRowId, setOpenRowId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteSpecialtieId, setDeleteSpecialtieId] = useState('');
  const [openForm, setOpenForm] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const handleClick = (event, rowId) => {
    setAnchorEl(event.currentTarget);
    setOpenRowId(rowId);
  };
  const handleCloseTableModal = () => {
    setAnchorEl(null);
    setOpenRowId(null);
  };

  function handleDeleteSpecialtie(id) {
    apiService
      .post(`moh_manager/delete/specialties`, {
        id: id,
      })
      .then((res) => {
        toast.success(res.message);
        fetchSpecialties();
        setIsModalOpen(false);
        setDeleteSpecialtieId('');
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log('Error Deleting specialties', err);
      });
  }

  function handleCreateSpecialtie(values) {
    apiService
      .post('moh_manager/create/specialties', {
        name: values.specialtiesName,
        description: values.description,
      })
      .then((res) => {
        toast.success(res.message);
        fetchSpecialties();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log('Error creating specialties', err);
      });
  }

  function handleUpdateSpecialtie(values) {
    apiService
      .post(`moh_manager/update/specialties`, {
        name: values.specialtiesName,
        id: editableSpecialtie?.id,
        description: values.description,
      })
      .then((res) => {
        toast.success(res.message);

        fetchSpecialties();
        setEditableSpecialtie(null);
        setIsEdit(false);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log('Error Updating specialties', err);
      });
  }

  function handleSpecialtieSubmit(values, { resetForm }) {
    if (isEdit) {
      handleUpdateSpecialtie(values);
    } else {
      handleCreateSpecialtie(values);
    }
    setOpenForm(false);
    resetForm();
  }

  const columns = [
    {
      id: 'Specialtie Name',
      header: 'Specialtie Name',

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.specialtiesName}
          </span>
        );
      },
    },
    {
      id: 'Description',
      header: 'Description',

      accessorFn: (row) => {
        return (
          <span className="line-clamp-1 self-stretch overflow-hidden text-[#0A0D14] text-ellipsis font-inter text-sm font-normal leading-[20px] tracking-[-0.084px]">
            {row?.description ? row?.description : ''}
          </span>
        );
      },
    },
  ];
  const renderRowActions = ({ row, table }) => {
    const isOpen = openRowId === row.index;

    return (
      <>
        <div className="flex gap-3">
          <Dots
            className="action-icon cursor-pointer"
            onClick={(e) => handleClick(e, row?.index)}
          />
        </div>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={isOpen}
          onClose={handleCloseTableModal}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={{
            boxShadow: 'none', // Removing box shadow
          }}
        >
          <MenuItem
            sx={{
              fontSize: '18px',
              padding: '1px 24px',
              minWidth: '150px',
              borderRadius: '16px',
              '&:hover': {
                backgroundColor: '#FFF',
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsEdit(true);
                  setOpenForm(true);
                  setEditableSpecialtie({
                    name: row?.original?.specialtiesName,
                    description: row?.original?.description,
                    id: row?.original?.id,
                  });
                }}
              >
                Edit
              </p>
            </div>
          </MenuItem>
          <MenuItem
            sx={{
              fontSize: '18px',
              padding: '1px 24px',
              minWidth: '150px',
              borderRadius: '16px',
              '&:hover': {
                backgroundColor: '#FFF',
              },
            }}
          >
            <div
              className="flex justify-between w-[100%] "
              onClick={() => {
                setAnchorEl(null);
                setOpenRowId(false);
              }}
            >
              <p
                className="self-center m-1 "
                onClick={() => {
                  setIsModalOpen(true);
                  setDeleteSpecialtieId(row?.original?.id);
                }}
              >
                Delete
              </p>
            </div>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleRenderRowActions = ({ row, table }) =>
    renderRowActions({ row, table });

  const fetchSpecialties = async (page, rowsPerPage) => {
    try {
      const { data } = await apiService.get(
        `moh_manager/all/specialties?is_pagination=true&per_page=${rowsPerPage}&page=${page}`
      );

      setTotalRows(data?.total);
      setSpecialties(
        data?.data.map(({ name, _id, description, ...rest }) => ({
          specialtiesName: name,
          description: description,
          id: _id,
          ...rest,
        }))
      );
    } catch (e) {
      console.log('Error fetching specialties:', e);
    }
  };

  useEffect(() => {
    fetchSpecialties(page, rowsPerPage);
  }, [page, rowsPerPage, specialties]);

  const initialValues = {
    specialtiesName: editableSpecialtie?.name ? editableSpecialtie?.name : '',
    description: editableSpecialtie?.description
      ? editableSpecialtie?.description
      : '',
  };
  const validationSchema = Yup.object({
    specialtiesName: Yup.string().required('Specialtie Name is required'),
    description: Yup.string().required('Description is required'),
  });
  return (
    <Container>
      <div className="flex gap-2 mb-4">
        <h1>Specialty</h1>
        <div
          className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full transition-transform transform duration-200 
                hover:shadow-lg hover:scale-105 active:scale-95 cursor-pointer"
          onClick={() => setOpenForm(true)}
        >
          <FaPlus className="text-green-500 text-3xl" />
        </div>
      </div>
      <CustomModal
        isOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={'Delete Specialtie'}
        bodyText={'Are you want to Delete this specialties?'}
        buttonText={'Delete'}
        onClick={() => handleDeleteSpecialtie(deleteSpecialtieId)}
      />
      {openForm && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
            <Formik
              initialValues={initialValues}
              enableReinitialize={true}
              validationSchema={validationSchema}
              onSubmit={handleSpecialtieSubmit}
            >
              {({ values, errors, touched, setFieldValue, handleChange }) => (
                <ModalBody>
                  <Form>
                    <div className="">
                      <div>
                        <InputField
                          isRequiredClass="text-[#2D9F75]"
                          label="Specialtie Name"
                          name="specialtiesName"
                          isRequired={true}
                          height="h-[40px]"
                          value={values.specialtiesName}
                          onChange={(e) => handleChange(e)}
                        />
                        {touched.specialtiesName && errors.specialtiesName && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.specialtiesName}
                          </div>
                        )}
                      </div>
                      <div>
                        <InputField
                          isRequiredClass="text-[#2D9F75]"
                          label="Description Name"
                          name="description"
                          isRequired={true}
                          height="h-[40px]"
                          value={values.description}
                          onChange={(e) => handleChange(e)}
                        />
                        {touched.description && errors.description && (
                          <div className="text-red-500 text-sm mt-1">
                            {errors.description}
                          </div>
                        )}
                      </div>
                      <div className="d-flex justify-content-end self-end gap-2 mt-4">
                        <Button color="success" type="submit">
                          {!isEdit ? 'Submit' : 'Update'}
                        </Button>
                        <Button
                          color="danger"
                          type="submit"
                          onClick={() => {
                            setIsEdit(false);
                            setOpenForm(false);
                            setEditableSpecialtie(null);
                          }}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </Form>
                </ModalBody>
              )}
            </Formik>
          </div>
        </div>
      )}

      <DataTableReact
        data={specialties}
        columns={columns}
        renderRowActions={handleRenderRowActions}
        setPage={setPage}
        page={page}
        setRowsPerPage={setRowsPerPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        shouldShowActions={true}
      />
    </Container>
  );
}

export default Specialties;
